"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.block = exports.inline = void 0;
var inline_1 = require("./inline");
Object.defineProperty(exports, "inline", { enumerable: true, get: function () { return inline_1.inline; } });
var block_1 = require("./block");
Object.defineProperty(exports, "block", { enumerable: true, get: function () { return block_1.block; } });
